import {createReducer, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
import * as TemplateFieldActions from '../_actions/template-field-entity.actions';
import {IFullTemplateField} from '../_interface/itemplate-field';

export const featureKey = 'templateFieldEntities';

export interface State extends EntityState<IFullTemplateField> {
	loaded: boolean;
}

export const adapter: EntityAdapter<IFullTemplateField> = createEntityAdapter<IFullTemplateField>(
	{selectId: model => model.templateFieldId}
);

export const initialState: State = adapter.getInitialState({
	loaded: false
});


export const reducer = createReducer(
	initialState,
	on(TemplateFieldActions.loadTemplateFields,
		(state, action) => {
			return adapter.setAll(action.templateFields, {...state, loaded: true});
		}),
	on(TemplateFieldActions.loadTemplateField,
		(state, action) => {
			return adapter.upsertOne(action.templateField, {...state, loaded: true});
		}),
	on(TemplateFieldActions.upsertManyTemplateFields,
		(state, action) => {
			return adapter.upsertMany(action.templateFields, state);
		})
);
